import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { StatusService } from 'src/app/services/status.service';

@Component({
  selector: 'ap-money',
  templateUrl: './money-input.component.html',
  styleUrls: ['./money-input.component.scss']
})
export class MoneyInputComponent implements OnChanges {

    public hasError = false;

    public displayAmount = "0";
    public placeholderAmount = "";

    public hasHadInput = false;


    @Input() amount: number | null = 0;
    @Input() outline: boolean = false;
    @Input() inDollars: boolean = false;
    @Input() noZeroValue: boolean = false;
    @Input() max: number | null = null; 
    @Input() negativeOnly: boolean = false;
    @Input() readonly: boolean = false;
    @Input() displayCents: boolean = true;

    // Attach to this in the parent to
    // detect changes
    @Output() amountChange = new EventEmitter();
    change(newValue: any) {
        this.hasError = false;

        if (this.noZeroValue) {
            if (newValue == '') {
                this.placeholderAmount = '';
                this.amount = null;
                return;
            }
        }

        let multiplier = 100;
        if (this.inDollars) {
            multiplier = 1;
        }

        if (newValue[0] == "$") {
            newValue = newValue.replace('$', '');
        }

        newValue = newValue.replace(/[ ]*,[ ]*|[ ]+/g, '');

        // Check if not a number
        if (isNaN(newValue)) {
            this.hasError = true;
        }
 
        // Check if has two decimal places
        let convertit = new Intl.NumberFormat('en-US', { 
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            useGrouping: false,
            currency: 'AUD' }).format(newValue);

        let tocents = +convertit.replace('$', '');

        if (this.max != null) {
            if (tocents > (this.max * multiplier)) {
                tocents = this.max * multiplier;
            }
        }

        if (!this.inDollars) {
            tocents = Math.round(tocents * multiplier);
        }
        
        if (this.negativeOnly) {
            tocents = Math.abs(tocents) * -1;
        }

        this.amount = tocents;

        this.statusService.setText(new Intl.NumberFormat('en-US', { 
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            maximumFractionDigits: this.displayCents ? 2 : 0,
            currency: 'AUD' }).format(tocents / Math.abs(multiplier)));
    }

    constructor(private statusService: StatusService) {}

    ngOnInit(): void {

        let multiplier = 100;
        if (this.inDollars) {
            multiplier = 1;
        }

        if (this.noZeroValue) {
            this.displayAmount = '';

            if (this.amount != null) {
                this.displayAmount = this.formatAmount(this.amount, multiplier);
            }
        } else {
            if (this.amount == null) {
                this.amount = 0;
            }

            this.displayAmount = this.formatAmount(this.amount, multiplier);
        }
    }

    update() {
        
    }

    ngOnChanges() {
        this.ngOnInit();
    }

    onFocus() {
        this.hasHadInput = false;
        this.placeholderAmount = this.displayAmount;
        this.displayAmount = "";
    }

    onEnter() {
        this.onBlur();
    }

    onBackspace() {
        if (!this.hasHadInput) {
            if (this.noZeroValue) {
                this.placeholderAmount = '';
                this.amount = null;
            } else {
                this.placeholderAmount = this.displayCents ? '$0.00' : '$0';
                this.amount = 0;
            }

            this.hasHadInput = true;
        }
    }

    onBlur() {
        this.statusService.clear();

        let multiplier = 100;
        if (this.inDollars) {
            multiplier = 1;
        }

        this.displayAmount = this.formatAmount(this.amount, multiplier);

        if (this.noZeroValue) {
            if (this.amount == 0 || this.amount == null) {
                this.displayAmount = '';
                this.amount = null;
                this.amountChange.emit(null);
            } else {
                this.amountChange.emit(+this.amount);    
            }
        } else {
            this.amountChange.emit(+this.amount);
        }

        // if (this.negativeOnly) {
        //     this.amount = Math.abs(this.amount) * -1
        // }
        console.log(this.amount)
    }

    private formatAmount(amount: number | null, multiplier: number) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            useGrouping: true,
            minimumFractionDigits: this.displayCents ? 2 : 0,
            maximumFractionDigits: this.displayCents ? 2 : 0,
            currency: 'AUD'
        }).format(+(amount || 0) / multiplier);
    }

}
